import React from 'react'

const Complete = () => {
  return (
    <div class="fill">
        <h3>You have no pending tasks!</h3>
        <br></br>
        <p>Go enjoy your free time and hope you liked using Questify.</p>
    </div>
  )
}

export default Complete